import { LocationContainer } from '../../features/master-data/location/LocationContainer';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';

export const MasterDataLocation = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Locations'
  })
)(LocationContainer);
